<template>
	<div class="chat-wrap" style="width:100%; height:100%; display:flex; flex-direction:column; background:#f9f9f9;">
		<!-- 标题 -->
		<div class="chat-title"
			style="flex-shrink:0; padding:12px 20px; border-bottom:1px solid #eee; font-weight:600;">
			{{ currentStudentName || '暂未选择学生' }}
		</div>

		<!-- 聊天列表 -->
		<div v-if="!currentStudentId"
			style="flex:1; display:flex; align-items:center; justify-content:center; color:#999;">
			请点击左侧学生查看对话
		</div>

		<div v-else id="chatContainer" style="flex:1; overflow-y:auto; padding:16px 20px;">
			<div v-for="(msg, idx) in chatList" :key="idx" class="msg-item" :class="msg.role">
				<div class="avatar">
					{{ msg.role === 'student' ? '👨‍🎓' : (msg.role === 'ai' ? '🤖' : '👨‍🏫') }}
				</div>
				<div class="msg-content">
					<div class="msg-time">{{ formatTime(msg.createTime) }}</div>
					{{ msg.content }}
				</div>
			</div>
		</div>

		<!-- 输入框 -->
		<div v-if="currentStudentId&&!isSave" class="input-area"  
			style="flex-shrink:0; padding:10px 20px; background:#fff; border-top:1px solid #eee; display:flex; gap:12px; align-items:center;">
			<el-input v-model="inputContent" placeholder="请输入要干预学生的消息..." style="flex:1"
				@keyup.enter.native="handleSend" :disabled="isSave" />
			<el-button type="primary" icon="el-icon-send" @click="handleSend" style="min-width:90px"
				:disabled="!inputContent.trim()||!isSave" >
				发送
			</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: "StudentChat",
		props: {
			currentStudentId: {
				type: String,
				default: ""
			},
			currentStudentName: {
				type: String,
				default: ""
			},
			isSave: {
				type: Boolean,
				default: false
			},
			chatList: {
				type: Array,
				default: () => []
			},
			schoolId: [String, Number],
			courseClassId: [String, Number],
			teacherId: [String, Number],
			
		},
		data() {
			return {
				inputContent: "",
				timer: null
			};
		},
		watch: {
			currentStudentId(newVal, oldVal) {
				if (newVal && newVal !== oldVal) {
					this.getChatList();
					this.startPollChat();
				}
			},
			chatList() {
				this.scrollBottom();
			}
		},
		beforeDestroy() {
			if (this.timer) clearInterval(this.timer);
		},
		methods: {
			formatTime(timestamp) {
				if (!timestamp) return "";
				const date = new Date(timestamp);
				const y = date.getFullYear();
				const m = String(date.getMonth() + 1).padStart(2, "0");
				const d = String(date.getDate()).padStart(2, "0");
				const h = String(date.getHours()).padStart(2, "0");
				const min = String(date.getMinutes()).padStart(2, "0");
				const s = String(date.getSeconds()).padStart(2, "0");
				return `${y}-${m}-${d} ${h}:${min}:${s}`;
			},
			scrollBottom() {
				this.$nextTick(() => {
					const container = document.getElementById("chatContainer");
					if (container) container.scrollTop = container.scrollHeight;
				});
			},
			async getChatList() {
				if (!this.currentStudentId) return;
				try {
					const {
						data
					} = await this.API.get(this.API.school.getWithRoleList, {
						schoolId: this.schoolId,
						courseClassId: this.courseClassId,
						studentId: this.currentStudentId
					});
					this.$emit("update-chat-list", data.data || []);
					this.scrollBottom();
				} catch (e) {
					console.error("加载对话失败：", e);
					this.$emit("update-chat-list", []);
				}
			},
			startPollChat() {
				if (this.timer) clearInterval(this.timer);
				this.timer = setInterval(async () => {
					if (!this.currentStudentId) return;
					const last = this.chatList.length > 0 ? Math.max(...this.chatList.map(m => m.createTime ||
						0)) : 0;
					try {
						const {
							data
						} = await this.API.get(this.API.school.getTeacherChatNew, {
							schoolId: this.schoolId,
							courseClassId: this.courseClassId,
							studentId: this.currentStudentId,
							lastTime: last
						});
						if (data.data.length > 0) {
							this.$emit("append-chat-list", data.data);
						}
					} catch (e) {}
				}, 3000);
			},
			async handleSend() {
				console.log(this.isSave)
				return
				const content = this.inputContent.trim();
				if (!content) return this.$message.warning("请输入干预消息内容！");
				if (!this.currentStudentId) return this.$message.warning("请先选择要干预的学生！");
				try {
					const {
						data
					} = await this.API.post(this.API.school.postStudentChat, {
						schoolId: Number(this.schoolId),
						courseClassId: Number(this.courseClassId),
						studentId: Number(this.currentStudentId),
						teacherId: Number(this.teacherId),
						content: content,
						role: "teacher"
					});
					if (data.code === 200) {
						this.inputContent = "";
						this.$message.success("干预消息发送成功！");
						this.getChatList();
						this.$emit("refresh-student-list");
					} else {
						this.$message.error("发送失败：" + (data.msg || "服务器错误"));
					}
				} catch (e) {
					console.error("发送教师干预消息失败：", e);
					this.$message.error("发送失败，请重试！");
				}
			}
		}
	};
</script>

<style scoped>
	.chat-title {
		font-size: 20px !important;
		font-weight: bold;
	}

	.empty-tip {
		font-size: 18px;
	}

	.avatar {
		font-size: 32px;
		margin: 0 12px;
	}

	.msg-content {
		font-size: 18px;
		line-height: 1.7;
		padding: 14px 18px;
		border-radius: 14px;
	}

	.msg-time {
		font-size: 14px;
		margin-bottom: 8px;
	}

	.input-area .el-input,
	.input-area .el-button {
		font-size: 16px !important;
	}

	.msg-item {
		display: flex;
		margin: 20px 0;
		max-width: 90%;
		width: fit-content;
	}

	.msg-item.student,
	.msg-item.ai {
		margin-right: auto;
		flex-direction: row;
	}

	.msg-item.teacher {
		margin-left: auto;
		flex-direction: row-reverse;
	}

	.msg-content {
		background: #f1f1f1;
		padding: 18px 24px;
		border-radius: 20px;
		box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
		white-space: pre-wrap;
		word-break: break-all;
	}

	.msg-item.student .msg-content {
		background: #2d8cf0;
		color: #fff;
	}

	.msg-item.ai .msg-content {
		background: #67C23A;
		color: #fff;
	}

	.msg-item.teacher .msg-content {
		background: #ff7d00;
		color: #fff;
	}
</style>